import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { DateAdapter, MatNativeDateModule, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';

import { EuiDateRangeSelectorComponent } from './eui-date-range-selector.component';
import { EuiButtonModule } from '../eui-button/eui-button.component';
import { EuiIconModule } from '../atoms/eui-icon/eui-icon.module';

export const DEFAULT_FORMATS = {
    parse: {
        dateInput: 'DD/MM/YYYY',
    },
    display: {
        dateInput: 'DD/MM/YYYY',
        monthYearLabel: 'DD/MM/YYYY',
        dateA11yLabel: 'DD/MM/YYYY',
        monthYearA11yLabel: 'DD/MM/YYYY',
    },
};
@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        TranslateModule,
        MatDatepickerModule,
        MatNativeDateModule,
        EuiButtonModule,
        EuiIconModule
    ],
    exports: [
        EuiDateRangeSelectorComponent,
    ],
    declarations: [
        EuiDateRangeSelectorComponent,
    ],
    providers: [
        { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
        { provide: MAT_DATE_FORMATS, useValue: DEFAULT_FORMATS },
    ]
})
export class EuiDateRangeSelectorModule {
}
